module.exports = __webpack_public_path__ + "img/game_icon_goal.092cb828.png";